import createUseContext from 'constate';
import { useReducer } from 'react';
import { repo } from 'index';
import { errorHandler } from 'helpers/error-handler';
import { createReducer } from 'helpers/reducers-helper';
import merge from 'lodash/merge';
import { EMAIL, fieldCheck } from 'helpers/rule-validation';

export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const SUBMIT_START_EMAIL = 'SUBMIT_START_EMAIL';
export const ERROR_EMAIL = 'ERROR_EMAIL';
export const RESET = 'RESET';

export const useEmail = (email, onUpdateUserInfo) => {
  const initState = {
    email: email,
    loading: false,
    error: '',
  };

  const changeEmail = (state, payload) => merge(state, { email: payload });
  const submitStartEmail = state => merge({}, state, { loading: true });
  const errorEmail = (state, payload) => merge({}, state, { error: payload, loading: false });
  const reset = () => initState;

  const modifyEmail = () => {
    const emailCheck = () => {
      const emailValidation = fieldCheck(EMAIL, state.email);
      dispatch({ type: ERROR_EMAIL, payload: emailValidation.error });
      return emailValidation.success;
    };

    if (!emailCheck()) return;

    dispatch({ type: SUBMIT_START_EMAIL });
    repo
      .updateUserInfo(state.email, undefined)
      .then(value => {
        dispatch({ type: RESET });
        onUpdateUserInfo(value);
      })
      .catch(error => {
        dispatch({
          type: ERROR_EMAIL,
          payload: errorHandler(error),
        });
      });
  };

  const reducer = createReducer(
    {
      [CHANGE_EMAIL]: changeEmail,
      [SUBMIT_START_EMAIL]: submitStartEmail,
      [ERROR_EMAIL]: errorEmail,
      [RESET]: reset,
    },
    initState
  );

  const [state, dispatch] = useReducer(reducer, initState);

  return {
    state,
    dispatch,
    modifyEmail,
  };
};

export const useEmailContext = createUseContext(useEmail);
